import React from "react";
import {Link} from "react-router-dom";
import './Header.css';
import logo from '../logo.svg';
interface Props {

}

export default class Header extends React.Component<Props, any> {
    state = {
        "data": [
            {
                "title": "Наука",
                "data": [{
                    "link": "",
                    "text": ""
                }]
            },
            {
                "title": "",
                "link": ""
            },
        ]
    }

    async componentDidMount(): Promise<void> {
        const response = await fetch(`${process.env.PUBLIC_URL}/configs/Navigation.json`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const dataURL = await response.json();
        this.setState({
            data: dataURL,
        });
    }

    render() {
        return <>
            <div className="sticky-top top-0 hide-on-android">
                <header className="py-3 border-bottom text-bg-light bg-white">
                    <div className="container d-flex justify-content-between border-bottom border-1 border-dark">
                        <div className="col-auto">
                            <p>
                        <span className="fw-bold">
                            Контакты:
                        </span>
                                <i className="bi bi-telephone-fill"></i>+375291800508,
                                <i className="bi bi-envelope-fill"></i>confucius@m.msu.by
                            </p>
                        </div>
                        <div className="col-auto">
                            <div className="dropdown d-flex justify-content-center align-middle">
                                <p className="dropdown-toggle text-center m-0 pt-2" id="lang" data-bs-toggle="dropdown"
                                   aria-expanded="false">
                                    <img src={`${process.env.PUBLIC_URL}/images/icons/ru_RU.png`} alt={`Русский`}/>Русский
                                </p>
                                <ul className="dropdown-menu p-2" aria-labelledby="lang">
                                    <li className="border-bottom border-1 p-1">
                                        <Link className="dropdown-item text-decoration-none text-dark" to="#">
                                            <img src={`${process.env.PUBLIC_URL}/images/icons/en_EN.png`}
                                                 alt={`English`}/>English
                                        </Link>
                                    </li>
                                    <li className="p-1">
                                        <Link className="dropdown-item text-decoration-none text-dark" to="#">
                                            <img src={`${process.env.PUBLIC_URL}/images/icons/zh_CN.png`}
                                                 alt={`中國人`}/>中國人
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="container d-flex flex-wrap justify-content-between pt-2 px-0 bg-white">
                        <Link to="/"
                              className="col-auto d-flex align-items-center mb-3 text-decoration-none text-dark">
                            <img src={logo} className="logo" alt={"логотип"}/>
                            <span className="fs-4 ps-3 text-wrap">Институт Конфуция<br/> МГУ имени А. А. Кулешова</span>
                        </Link>
                        <div className="col-auto d-flex py-3">
                            <input type="search" className="form-control align-middle" placeholder="Найти..."
                                   aria-label="Search"/>
                        </div>
                    </div>
                </header>
                <nav className="py-2 border-bottom bg-main-color">
                    <div className="container d-flex flex-wrap p-0">
                        <ul className="nav me-auto col-12 d-flex justify-content-between">
                            {this.state.data.map((item, index) => (
                                ("data" in item) ?
                                    <li className="col-auto">
                                        <div className="hover-dropdown d-flex justify-content-center align-middle">
                                            <p className="dropdown-toggle text-center m-0 pt-2 text-white fs-4"
                                               id={`header-${index}`}>
                                                {item.title}
                                            </p>
                                            <ul className="hover-dropdown-menu bg-main-color p-3 hover-dropdown-mt"
                                                aria-labelledby={`header-${index}`}>
                                                {(item.data !== undefined) ?
                                                    item.data.map((item2, index) => (
                                                        <li className="mb-2 headers-links">
                                                            <Link className="text-white fs-4 text-decoration-none"
                                                                  to={item2.link}>
                                                                {item2.text}
                                                            </Link>
                                                        </li>
                                                    )) :
                                                    <></>}
                                            </ul>
                                        </div>
                                    </li>
                                    :
                                    <li className="col-auto">
                                        <div className="d-flex headers-links-transp w-100">
                                            <Link to={item.link}
                                                  className="text-white text-decoration-none pt-1 w-100">
                                                <p className="text-center m-0 fs-4">
                                                    {item.title}
                                                </p>
                                            </Link>
                                        </div>
                                    </li>
                            ))}
                        </ul>
                    </div>
                </nav>
            </div>
        </>
            ;
    }
}